import React from 'react';
import {Breadcrumbs,Typography,Link, Box} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import axios from 'axios';
import qs from 'qs';
import { authUser } from '../funciones/AuthUser'
import { useHistory } from "react-router-dom";
import PerfilExt from './PExterno'
import CoordinadorSecc from './CoorSeccional'
//import PerfilExt from './PublicoInicio';
const useStyles = makeStyles((theme) => ({
    textoSelect: {
      '&:hover': {
        color:'#9ccdfa',
      },
      fontSize:1.25+'rem'
    },
}));

const PerfilExterno = () => {
    let history = useHistory();     
    const classes = useStyles();    
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext); 
    const[listMuni,setListMuni]=React.useState([]);
    const[opcion,setOpcion]=React.useState(3)
    const [espera,setEspera]=React.useState(false);
    const usuID = localStorage.getItem('UsuId');
    React.useEffect(()=>{
        const usu = localStorage.getItem('UsuarioNom');
        
        let usuTipo =localStorage.getItem('Tipo') ;    
        const nvl= localStorage.getItem('Tipo');    
        const source = axios.CancelToken.source();    
      
        async function llamadaListMuni()  {       
            setEspera(true) ;        
            let auxU= process.env.REACT_APP_LINK +`/lugar-municipio-tipo`;               
            let token =localStorage.getItem('token20') ;               
            let dataInfo = qs.stringify({                
                'usuario':usuID,              
                'estado':process.env.REACT_APP_EDO,                
                'tipo':usuTipo,
                'idDispositivo':'w8rf51v21dsd2cs',
                });
            let config = {
                url:auxU ,
                method: 'POST',
                headers: { 'access-token' : token, 'Content-Type': 'application/x-www-form-urlencoded' },
                data: dataInfo,
                cancelToken: source.token
            };
            let aux ={};           
            await axios(config)
            .then(function (response) {                
                aux=  response.data;                           
                if (aux[0].Id != -1) 
                {   //console.log(aux);  
                    // guardarSinDatos(true)                                                           
                    setListMuni(aux)
                }
                else
                { 
                //guardarSinDatos(false)       
                }                                            
            })
            .catch(function (error) {                
            console.log(error);        
            if( error && error.response && error.response.data && error.response.data.mensaje==="Datos Incorrectos")
            {
                console.log('datos incorrectos' );  
            }else
            {
                if ( ( error && error.response && error.response.data && error.response.data.error.name==="JsonWebTokenError" )||
                    ( error && error.response && error.response.data && error.response.data.error.name==="TokenExpiredError" ) ) 
                {
                console.log('loguearse de nuevo');
                localStorage.clear();                      
                history.push("/");                              
                } 
            }
            });              
            setEspera(false)  ;
        };
      
        const veriSesion =  () => {            
            let auxValidacion=authUser()
            if(!auxValidacion ||(usu===undefined||usu===''||usu===null)||(nvl===undefined||nvl===''||nvl===null)
                ||(usuID===undefined||usuID===''||usuID===null) )
            {   guardarUsuario([])				
                guardarGenerales([])    
                localStorage.clear();            	             
                history.push("/")	                	
            }
            else
            {   
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                         
                    
                }        
                  
                llamadaListMuni();                                 
                guardarGenerales({...generales,Titulo:process.env.REACT_APP_Promov})                                                       
            }   
        }
        veriSesion()
    },[])
    
    const selectOpcion =(e,auxValor)=>{
        e.preventDefault();
        //console.log(auxValor);
        setOpcion(auxValor)
    }

    const menuAdmin=(<Breadcrumbs separator="-" aria-label="breadcrumb" > {/*nivel administrador */}
                <Typography variant="h5" className={classes.textoSelect} 
                    color={opcion === 3 ? "Primary":'textPrimary'} onClick={e=>selectOpcion(e,3)}
                >
                    Externo
                </Typography>
            </Breadcrumbs>
            )

   

    const filtraTipo=()=>{
        const nvl= parseInt(localStorage.getItem('Tipo'));   
        //console.log(nvl);
        let opciones=null 
        switch (nvl) {
            case 7 :
                opciones=menuAdmin                
                break;
            case 1 :
                opciones=menuAdmin                
                break;
            default:
                break;
        }
        return(opciones)
    }

    const contenido5 = opcion === 5 ? <CoordinadorSecc listMuni={listMuni} /> : null                        
    const contenido = opcion === 3 ? <PerfilExt  listMuni={listMuni} /> : contenido5  

    return( 
    <div>
        <Box display="flex" pt={2} pb={1} style={{justifyContent:'center'}}>
            {filtraTipo()}
        </Box>
        {contenido}
    </div>
    );
};

export default PerfilExterno;
